var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 776,
    height: 759,
    viewBox: "0 0 776 759",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_15299)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.741 766.355C115.634 759.129 112.137 748.258 106.65 735.458C103.802 728.813 101.522 724.225 95.5591 712.484C74.7587 671.527 72.8543 668.982 74.1691 663.367C76.9748 651.385 90.4561 642.439 101.897 634.847C112.378 627.892 116.868 627.774 119.325 622.172C123.261 613.202 114.608 606.991 109.027 587.314C104.49 571.318 105.152 557.595 105.858 542.95C106.575 528.085 108.95 516.166 109.819 512.054C113.88 492.825 117.804 488.903 117.741 475.612C117.684 463.543 114.389 454.15 112.988 450.261C110.162 442.416 107.838 439.887 96.3511 418.573C92.3252 411.103 90.3126 407.368 89.2211 405.105C84.8839 396.112 76.1149 377.491 74.9614 353.611C74.4922 343.896 74.2576 339.038 76.5458 333.014C79.3963 325.509 83.6538 322.434 92.3901 310.04C97.5463 302.725 100.101 299.05 101.104 296.572C106.816 282.47 101.188 267.68 99.5201 263.299C91.9911 243.516 80.0922 243.314 75.7538 228.442C72.8156 218.369 75.9797 210.598 82.8834 192C106.729 127.761 108.004 115.349 118.533 113.571C131.16 111.438 149.783 125.834 153.39 128.623C160.553 134.16 163.67 138.652 170.027 138.921C180.043 139.346 188.028 128.863 190.625 125.454C203.687 108.304 196.381 96.4887 204.884 81.0898C214.209 64.2044 233.828 58.7916 256.378 52.5702C272.093 48.2348 295.398 41.805 320.548 50.1935C347.19 59.0801 353.917 77.2639 374.418 74.7521C380.982 73.9479 387.509 70.2548 400.561 62.8689C420.439 51.6215 424.109 44.5815 436.211 42.2713C445.188 40.5575 450.238 43.0824 464.731 47.0247C492.428 54.5586 488.694 49.3375 542.367 59.7001C542.367 59.7001 559.693 63.0451 582.77 66.83C595.042 68.8427 597.369 69.082 600.199 69.2066C618.763 70.0238 621.751 64.2631 639.81 62.8689C648.048 62.2329 644.587 63.651 684.966 69.2066C688.392 69.6779 693.487 70.3653 698.434 73.9599C705.016 78.7432 703.99 83.3358 708.732 88.2197C714.306 93.9594 721.339 93.4008 746.494 94.8215C746.494 94.8215 758.372 95.4924 769.733 96.406C786.389 97.7452 800.942 252.055 802.478 799.364",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.741 766.355C115.634 759.129 112.137 748.258 106.65 735.458C103.802 728.813 101.522 724.225 95.5591 712.484C74.7587 671.527 72.8543 668.982 74.1691 663.367C76.9748 651.385 90.4561 642.439 101.897 634.847C112.378 627.892 116.868 627.774 119.325 622.172C123.261 613.202 114.608 606.991 109.027 587.314C104.49 571.318 105.152 557.595 105.858 542.95C106.575 528.085 108.95 516.166 109.819 512.054C113.88 492.825 117.804 488.903 117.741 475.612C117.684 463.543 114.389 454.15 112.988 450.261C110.162 442.416 107.838 439.887 96.3511 418.573C92.3252 411.103 90.3126 407.368 89.2211 405.105C84.8839 396.112 76.1149 377.491 74.9614 353.611C74.4922 343.896 74.2576 339.038 76.5458 333.014C79.3963 325.509 83.6538 322.434 92.3901 310.04C97.5463 302.725 100.101 299.05 101.104 296.572C106.816 282.47 101.188 267.68 99.5201 263.299C91.9911 243.516 80.0922 243.314 75.7538 228.442C72.8156 218.369 75.9797 210.598 82.8834 192C106.729 127.761 108.004 115.349 118.533 113.571C131.16 111.438 149.783 125.834 153.39 128.623C160.553 134.16 163.67 138.652 170.027 138.921C180.043 139.346 188.028 128.863 190.625 125.454C203.687 108.304 196.381 96.4887 204.884 81.0898C214.209 64.2044 233.828 58.7916 256.378 52.5702C272.093 48.2348 295.398 41.805 320.548 50.1935C347.19 59.0801 353.917 77.2639 374.418 74.7521C380.982 73.9479 387.509 70.2548 400.561 62.8689C420.439 51.6215 424.109 44.5815 436.211 42.2713C445.188 40.5575 450.238 43.0824 464.731 47.0247C492.428 54.5586 488.694 49.3375 542.367 59.7001C542.367 59.7001 559.693 63.0451 582.77 66.83C595.042 68.8427 597.369 69.082 600.199 69.2066C618.763 70.0238 621.751 64.2631 639.81 62.8689C648.048 62.2329 644.587 63.651 684.966 69.2066C688.392 69.6779 693.487 70.3653 698.434 73.9599C705.016 78.7432 703.99 83.3358 708.732 88.2197C714.306 93.9594 721.339 93.4008 746.494 94.8215C746.494 94.8215 758.372 95.4924 769.733 96.406C786.389 97.7452 800.942 252.055 802.478 799.364",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M762.334 20.8828H9.20312V741.797H762.334V20.8828Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.704 770.844C168.251 768.83 166.986 756.766 159.197 743.381C151.503 730.158 145.475 729.451 142.297 719.087C138.193 705.704 143.848 692.557 146.522 686.342C150.869 676.236 153.341 677.78 164.479 658.878C171.994 646.124 174.058 640.009 175.042 636.696C177.667 627.856 177.999 620.791 178.211 615.571C178.677 604.059 179.283 589.109 171.873 575.432C165.868 564.346 161.791 567.376 151.804 554.306C147.074 548.117 133.999 531.008 135.959 510.998C136.668 503.765 139.306 496.512 144.41 482.479C148.422 471.446 149.239 471.656 149.691 467.691C151.461 452.171 139.14 447.333 141.241 434.946C142.693 426.384 148.809 427.345 154.973 412.764C157.167 407.573 159.823 401.289 159.197 393.751C158.71 387.878 156.369 382.917 146.522 370.512C129.355 348.887 124.371 348.721 120.115 337.768C118.711 334.153 114.433 323.141 118.002 311.36C122.176 297.584 133.041 296.092 132.791 287.066C132.474 275.682 115.049 272.986 114.834 260.659C114.74 255.319 117.997 255.063 123.284 241.646C127.087 231.995 128.988 227.17 128.565 222.633C127.191 207.883 108.79 204.504 108.496 192C108.337 185.273 113.479 178.377 119.059 175.1C136.578 164.81 156.145 191.532 182.436 184.606C196.449 180.915 204.988 169.611 212.012 160.312C225.694 142.199 232.511 116.908 234.194 110.666C237.826 97.1928 237.497 92.436 241.588 90.5969C254.626 84.7351 280.898 122.751 288.065 118.06C290.82 116.257 287.393 110.34 288.065 97.9909C288.452 90.8568 289.39 73.6133 300.74 65.2461C311.592 57.2459 329.392 59.2566 339.822 67.3586C348.232 73.8904 345.378 79.3536 358.835 100.103C370.778 118.518 376.79 120.021 379.961 120.173C385.439 120.435 389.665 117.014 394.749 112.779C409.312 100.649 406.282 92.6235 415.875 85.3154C421.86 80.7558 423.704 83.3739 462.352 78.9777C472.282 77.8481 476.986 77.1263 485.59 76.8652C509.641 76.1352 515.372 80.486 517.278 82.1466C523.383 87.465 521.216 92.16 526.785 95.8783C534.572 101.078 542.365 94.2712 557.417 92.7094C581.027 90.2598 583.116 104.8 607.062 102.216C618.282 101.005 625.851 96.9475 636.639 101.16C643.306 103.763 642.359 106.073 648.258 108.554C662.753 114.65 672.66 102.465 692.622 104.329C698.498 104.877 694.493 105.639 714.804 111.723C737.665 118.57 747.977 119.173 757.055 118.06C763.474 117.274 766.139 116.014 767.618 115.948C797.077 114.634 1012.52 557.632 792.969 780.351C583.265 993.08 175.892 802.8 168.704 770.844Z",
    fill: "#9E1F63",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.398 764.507C378.921 754.427 391.158 738.132 392.637 716.974C394.123 695.707 383.292 690.246 386.299 674.723C391.499 647.879 426.339 651.545 454.957 615.571C476.956 587.918 464.51 575.52 487.702 552.194C498.974 540.857 500.626 545.079 552.136 516.28C578.01 501.813 585.512 496.32 602.838 490.929C605.714 490.034 611.829 487.318 620.38 485.882C630.946 484.109 646.502 481.497 654.595 488.816C665.39 498.578 658.963 522.503 654.595 539.518C648.921 561.623 640.347 573.403 644.033 576.488C648.245 580.014 658.211 563.589 679.946 560.644C696.644 558.381 707.882 565.754 719.029 557.475C720.773 556.179 722.656 553.794 726.423 549.025C738.102 534.235 738.133 528.158 744.38 523.674C744.38 523.674 754.245 516.591 769.731 521.561C783.677 526.037 795.145 568.643 767.618 769.788",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.398 764.507C378.921 754.427 391.158 738.132 392.637 716.974C394.123 695.707 383.292 690.246 386.299 674.723C391.499 647.879 426.339 651.545 454.957 615.571C476.956 587.918 464.51 575.52 487.702 552.194C498.974 540.857 500.626 545.079 552.136 516.28C578.01 501.813 585.512 496.32 602.838 490.929C605.714 490.034 611.829 487.318 620.38 485.882C630.946 484.109 646.502 481.497 654.595 488.816C665.39 498.578 658.963 522.503 654.595 539.518C648.921 561.623 640.347 573.403 644.032 576.488C648.245 580.014 658.211 563.589 679.946 560.644C696.644 558.381 707.882 565.754 719.029 557.475C720.773 556.179 722.656 553.794 726.423 549.025C738.102 534.235 738.133 528.158 744.38 523.674C744.38 523.674 754.245 516.591 769.731 521.561C783.677 526.037 795.145 568.643 767.618 769.788",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.801 765.563C395.053 761.379 393.511 749.456 400.378 738.099C404.164 731.837 408.952 728.319 411.997 726.128C422.046 718.896 432.206 717.438 438.404 716.621C445.891 715.635 451.218 716.145 459.882 716.973C473.341 718.261 481.539 719.045 490.867 723.311C503.599 729.135 502.705 734.251 515.161 738.451C523.451 741.247 530.6 741.258 536.991 741.268C548.319 741.286 554.396 741.296 559.525 737.395C565.818 732.609 563.323 727.534 569.384 715.565C571.606 711.175 578.434 697.69 591.918 690.918C600.438 686.64 603.48 689.128 616.212 682.82C622.115 679.896 622.81 678.693 629.24 675.778C634.879 673.222 640.992 670.45 649.309 669.441C653.458 668.937 662.963 667.89 673.252 671.905C682.81 675.636 683.745 680.106 690.152 680.003C693.831 679.945 694.672 678.452 705.997 671.905C714.639 666.909 718.96 664.411 724.658 662.399C731.392 660.02 730.081 661.715 741.558 658.526C750.072 656.16 754.281 654.259 761.627 654.3C764.954 654.319 768.053 654.732 769.022 655.005C783.526 659.092 770.775 758.741 769.374 769.436",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.801 765.563C395.053 761.379 393.511 749.456 400.378 738.099C404.164 731.837 408.952 728.319 411.997 726.128C422.046 718.896 432.206 717.438 438.404 716.621C445.891 715.635 451.218 716.145 459.882 716.973C473.341 718.261 481.539 719.045 490.867 723.311C503.599 729.135 502.705 734.251 515.161 738.451C523.451 741.247 530.6 741.258 536.991 741.268C548.319 741.286 554.396 741.296 559.525 737.395C565.818 732.609 563.323 727.534 569.384 715.565C571.606 711.175 578.434 697.69 591.918 690.918C600.438 686.64 603.48 689.128 616.212 682.82C622.115 679.896 622.81 678.693 629.24 675.778C634.879 673.222 640.992 670.45 649.309 669.441C653.459 668.937 662.963 667.89 673.252 671.905C682.81 675.636 683.745 680.106 690.152 680.003C693.831 679.945 694.672 678.452 705.997 671.905C714.639 666.909 718.96 664.411 724.658 662.399C731.392 660.02 730.081 661.715 741.558 658.526C750.072 656.16 754.281 654.259 761.627 654.3C764.954 654.319 768.053 654.732 769.022 655.005C783.527 659.092 770.775 758.741 769.374 769.436",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.549 764.508C179.725 747.141 175.637 733.342 172.93 724.369C165.658 700.26 162.604 691.922 166.593 682.118C169.33 675.39 174.051 671.647 183.493 664.161C183.493 664.161 191.941 657.463 221.52 643.035C229.312 637.768 233.728 632.255 236.307 628.247C240.461 621.792 240.244 618.629 245.814 609.234C250.324 601.626 252.58 597.823 256.377 595.502C265.37 590.007 273.252 595.805 278.559 591.277C285.074 585.718 280.669 570.6 279.615 566.982C270.242 534.814 244.576 534.031 238.42 507.831C233.936 488.742 243.212 470.653 245.814 465.579C251.721 454.06 255.58 454.724 265.884 441.285C272.312 432.899 295.718 402.37 288.066 370.514C286.245 362.933 284.842 357.092 279.615 352.557C266.576 341.243 248.372 354.228 219.407 344.106C213.325 341.981 207.126 338.962 202.506 336.712C188.454 329.869 181.428 326.447 180.324 322.981C176.508 310.991 204.11 282.791 235.251 279.673C247.387 278.458 250.354 282.023 274.334 280.729C288.344 279.973 298.72 278.141 308.135 271.223C310.751 269.3 315.198 266.032 317.641 261.716C330.828 238.424 275.652 202.271 283.84 162.425C286.772 148.16 297.531 134.85 310.247 130.737C327.959 125.007 347.047 137.902 359.893 146.581C359.893 146.581 365.186 150.157 392.638 175.101C406.098 175.791 424.287 174.319 438.058 162.425C443.66 157.587 443.206 155.623 449.677 148.694C470.345 126.562 499.118 120.746 499.322 121.23C499.488 121.622 481.677 128.006 482.422 130.737C483.12 133.299 499.145 128.962 526.786 127.568C553.694 126.211 556.019 129.438 576.431 126.512C589.588 124.625 592.061 122.792 607.063 121.23C625.166 119.346 634.217 118.404 641.921 122.286C659.677 131.235 664.595 157.973 664.103 158.2C663.742 158.367 658.062 145.385 657.765 145.525C657.374 145.71 662.009 170.784 679.947 181.439C682.887 183.185 681.903 182.001 710.579 189.889C730.406 195.343 725.036 194.302 732.761 196.226C744.911 199.253 749.37 199.629 756 203.621C760.687 206.443 763.875 209.517 767.619 213.127C767.619 213.127 774.745 219.999 780.294 227.915C829.304 297.834 799.307 479.311 799.307 479.311C787.514 550.664 777.35 650.149 783.463 778.24",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.549 764.508C179.725 747.141 175.637 733.342 172.93 724.369C165.658 700.26 162.604 691.922 166.593 682.118C169.33 675.39 174.051 671.647 183.493 664.161C183.493 664.161 191.941 657.463 221.52 643.035C229.312 637.768 233.728 632.255 236.307 628.247C240.461 621.792 240.244 618.629 245.814 609.234C250.324 601.626 252.58 597.823 256.377 595.502C265.37 590.007 273.252 595.805 278.559 591.277C285.074 585.718 280.669 570.6 279.615 566.982C270.242 534.814 244.576 534.031 238.42 507.831C233.936 488.742 243.212 470.653 245.814 465.579C251.721 454.06 255.58 454.724 265.884 441.285C272.312 432.899 295.718 402.37 288.066 370.514C286.245 362.933 284.842 357.092 279.615 352.557C266.576 341.243 248.372 354.228 219.407 344.106C213.325 341.981 207.126 338.962 202.506 336.712C188.454 329.869 181.428 326.447 180.324 322.981C176.508 310.991 204.11 282.791 235.251 279.673C247.387 278.458 250.354 282.023 274.334 280.729C288.344 279.973 298.72 278.141 308.135 271.223C310.751 269.3 315.198 266.032 317.641 261.716C330.828 238.424 275.652 202.271 283.84 162.425C286.772 148.16 297.531 134.85 310.247 130.737C327.959 125.007 347.047 137.902 359.893 146.581C359.893 146.581 365.186 150.157 392.638 175.101C406.098 175.791 424.287 174.319 438.058 162.425C443.66 157.587 443.206 155.623 449.677 148.694C470.345 126.562 499.118 120.746 499.322 121.23C499.488 121.622 481.677 128.006 482.422 130.737C483.12 133.299 499.145 128.962 526.786 127.568C553.694 126.211 556.019 129.438 576.431 126.512C589.588 124.625 592.061 122.792 607.063 121.23C625.166 119.346 634.217 118.404 641.921 122.286C659.677 131.235 664.595 157.973 664.103 158.2C663.742 158.367 658.062 145.385 657.765 145.525C657.374 145.71 662.009 170.784 679.947 181.439C682.887 183.185 681.903 182.001 710.579 189.889C730.406 195.343 725.036 194.302 732.761 196.226C744.911 199.253 749.37 199.629 756 203.621C760.687 206.443 763.875 209.517 767.619 213.127C767.619 213.127 774.745 219.999 780.294 227.915C829.304 297.834 799.307 479.311 799.307 479.311C787.514 550.664 777.35 650.149 783.463 778.24",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.89 765.564C291.472 753.084 289.483 746.322 288.059 743.382C286.138 739.413 282.875 737.503 266.933 729.65C248.602 720.62 244.521 719.01 244.751 716.974C245.25 712.552 265.27 713.339 284.89 702.186C287.45 700.731 291.379 698.29 294.397 693.736C298.589 687.408 298.548 680.733 298.621 676.836C298.966 658.624 302.548 662.445 303.903 637.753C304.789 621.609 303.176 621.47 303.903 598.67C304.322 585.527 304.561 578.821 306.016 572.263C309.561 556.281 316.234 546.241 320.803 539.518C326.477 531.169 329.398 526.992 333.479 526.843C341.201 526.561 349.421 539.902 352.492 552.194C358.389 575.801 343.048 586.546 347.211 617.684C348.386 626.473 350.51 632.363 352.492 637.753C355.775 646.68 361.062 661.055 367.28 660.991C371.506 660.948 373.506 654.265 379.956 641.978C390.205 622.452 392.656 625.036 402.138 607.121C412.794 586.985 418.137 576.89 414.813 565.926C413.395 561.248 412.076 561.942 398.969 542.687C392.829 533.668 389.759 529.159 387.349 524.73C381.658 514.272 375.174 502.357 375.73 487.761C376.26 473.881 382.917 463.824 387.349 457.128C399.091 439.391 407.152 442.652 415.869 427.552C422.604 415.886 426.126 399.506 423.263 384.245C420.935 371.828 416.117 369.414 417.982 362.063C420.348 352.736 429.447 351.326 447.558 338.824C461.932 328.902 471.41 319.291 478.19 312.417C485.706 304.796 491.651 297.125 503.541 281.785C517.97 263.169 525.3 253.637 531.004 242.702C534.436 236.124 539.826 225.643 543.68 211.014C546.115 201.767 547.9 191.004 548.961 184.607C552.309 164.421 551.851 159.03 556.355 156.087C563.881 151.17 576.742 158.653 579.594 160.312C602.907 173.877 611.105 204.69 609.169 205.732C607.639 206.557 597.245 190.123 597.55 189.888C597.859 189.651 609.984 205.339 634.52 235.308C642.359 244.883 642.684 245.184 649.308 253.265C684.81 296.574 701.504 319.89 703.179 318.755C704.64 317.765 694.43 298.345 693.672 298.685C692.67 299.135 704.008 335.986 715.854 335.655C721.088 335.509 721.464 328.242 731.699 320.867C740.202 314.74 754.697 309.124 762.331 314.53C765.773 316.968 767.671 321.542 767.612 340.937C767.539 365.009 764.569 373.239 764.443 386.357C764.215 410.238 773.802 409.453 776.063 433.89C779.387 469.84 760.034 486.653 770.781 503.605C777.971 514.945 791.397 514.374 799.301 518.393C821.915 529.893 826.324 591.814 775.006 776.126",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.89 765.564C291.472 753.084 289.483 746.322 288.059 743.382C286.138 739.413 282.875 737.503 266.933 729.65C248.602 720.62 244.521 719.01 244.751 716.974C245.25 712.552 265.27 713.339 284.89 702.186C287.45 700.731 291.379 698.29 294.397 693.736C298.589 687.408 298.548 680.733 298.621 676.836C298.966 658.624 302.548 662.445 303.903 637.753C304.789 621.609 303.176 621.47 303.903 598.67C304.322 585.527 304.561 578.821 306.016 572.263C309.561 556.281 316.234 546.241 320.803 539.518C326.477 531.169 329.398 526.992 333.479 526.843C341.201 526.561 349.421 539.902 352.492 552.194C358.389 575.801 343.048 586.546 347.211 617.683C348.386 626.473 350.51 632.363 352.492 637.753C355.775 646.68 361.062 661.055 367.28 660.991C371.506 660.948 373.506 654.265 379.956 641.978C390.205 622.452 392.656 625.036 402.138 607.121C412.794 586.985 418.137 576.89 414.813 565.926C413.395 561.248 412.076 561.942 398.969 542.687C392.829 533.668 389.759 529.159 387.349 524.73C381.658 514.272 375.174 502.357 375.73 487.761C376.26 473.881 382.917 463.824 387.349 457.128C399.091 439.391 407.152 442.652 415.869 427.552C422.604 415.886 426.126 399.506 423.263 384.245C420.935 371.828 416.117 369.414 417.982 362.063C420.348 352.736 429.447 351.326 447.558 338.824C461.932 328.902 471.41 319.291 478.19 312.417C485.706 304.796 491.651 297.125 503.541 281.785C517.97 263.169 525.3 253.637 531.004 242.702C534.436 236.124 539.826 225.643 543.68 211.014C546.115 201.767 547.9 191.004 548.961 184.607C552.309 164.421 551.851 159.03 556.355 156.087C563.881 151.17 576.742 158.653 579.594 160.312C602.907 173.877 611.105 204.69 609.169 205.732C607.639 206.557 597.245 190.123 597.55 189.888C597.859 189.651 609.984 205.339 634.52 235.308C642.359 244.883 642.684 245.184 649.308 253.265C684.81 296.574 701.504 319.89 703.179 318.755C704.64 317.765 694.43 298.345 693.672 298.685C692.67 299.135 704.008 335.986 715.854 335.655C721.088 335.509 721.464 328.242 731.699 320.867C740.202 314.74 754.697 309.124 762.331 314.53C765.773 316.968 767.671 321.542 767.612 340.937C767.539 365.009 764.569 373.239 764.443 386.357C764.215 410.238 773.802 409.453 776.063 433.89C779.387 469.84 760.034 486.653 770.781 503.605C777.971 514.945 791.397 514.374 799.301 518.393C821.915 529.893 826.324 591.814 775.006 776.126",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M949.836 879.68V-16.9824L762.345 -16.9824V879.68H949.836Z",
    fill: "#6C3950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.144 119.596H283.312V288.651H341.144V119.596Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.679 431.349H142.34V489.081H327.679V431.349Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.837 519.185H155.758V577.808H330.837V519.185Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.609 616.627H137.543V654.3H293.609V616.627Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.609 718.823H137.543V741.797H293.609V718.823Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.847 577.809H293.613V741.797H330.847V577.809Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.144 340.145H160.52V388.47H280.144V340.145Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.149 324.3H280.148V355.988H341.149V324.3Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.742 242.702H54.3555V265.676H244.742V242.702Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.306 179.324H132V215.766H243.306V179.324Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.26 134.96H204.883V165.064H268.26V134.96Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.33 82.6748H54.3555V108.818H142.33V82.6748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.599 88.2197H170.812V119.594H231.599V88.2197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.143 54.1562H175.57V77.1305H280.143V54.1562Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.714 108.025H393.426V139.714H689.714V108.025Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.258 112.779H715.062V165.065H756.258V112.779Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.322 171.403H393.426V265.677H424.322V171.403Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.315 215.767H424.328V249.832H466.315V215.767Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.964 165.065H517.016V232.8H562.964V165.065Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.811 171.403H604.953V226.858H639.811V171.403Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.367 226.858H696.055V371.041H725.367V226.858Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.059 183.287H671.5V232.8H696.059V183.287Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.237 183.287H696.055V215.768H718.237V183.287Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.947 298.95H385.77V394.808H421.947V298.95Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.769 305.375H420.445V337.768H432.769V305.375Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.434 292.699H432.773V344.457H451.434V292.699Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.984 273.335H466.312V337.768H492.984V273.335Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.074 243.405H502.492V286.361H530.074V243.405Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.451 431.349H385.77V504.133H420.451V431.349Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.137 424.384H403.113V440.756H430.137V424.384Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.283 481.423H445.32V504.133H516.283V481.423Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.483 504.133H451.43V517.336H502.483V504.133Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.677 510.734H385.77V641.978H399.677V510.734Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.816 546.912H399.676V621.204H414.816V546.912Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.254 450.791H442.109V475.086H504.254V450.791Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.173 388.822H430.141V415.934H490.173V388.822Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.617 345.69H528.625V381.34H556.617V345.69Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.483 350.971H572.203V394.806H602.483V350.971Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.054 388.822H511.648V415.934H563.054V388.822Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.676 415.933H511.648V440.051H524.676V415.933Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.633 440.052H511.648V459.241H542.633V440.052Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.934 270.693H653.016V302.118H674.934V270.693Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.776 279.408H674.93V302.118H683.776V279.408Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.978 62.7803H589.805V92.5323H639.978V62.7803Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.166 62.7803H654.414V92.5323H684.166V62.7803Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.008 54.6836H379.691V88.2206H517.008V54.6836Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.662 56.3057H523.656V94.823H566.662V56.3057Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.445 62.3428H304.172V106.443H337.445V62.3428Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.817 62.3428H278.293V106.443H292.817V62.3428Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.371 62.3428H337.449V85.8451H345.371V62.3428Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.171 62.3428H292.816V92.1828H304.171V62.3428Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.339 134.96H83.1484V170.874H142.339V134.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.113 171.932H54.3555V209.166H106.113V171.932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.916 481.774H82.0859V563.813H103.916V481.774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.822 502.548H103.922V548.496H120.822V502.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.232 589.164H53.9258V607.121H122.232V589.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.227 568.011H105.672V589.163H122.227V568.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.491 619.092H75.75V640.57H108.491V619.092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8091 659.804H73.8477V684.765H98.8091V659.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.671 659.804H98.8047V676.484H105.671V659.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.227 658.526H105.672V697.961H122.227V658.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.665 659.804H139.836V693.033H186.665V659.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.604 654.3H162.363V659.802H178.604V654.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.859 409.331H83.1484V475.613H105.859V409.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1463 431.349H53.5703V454.04H83.1463V431.349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4554 365.494H76.2734V410.386H98.4554V365.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1463 402.201H53.5703V416.989H83.1463V402.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0511 358.63H53.5703V375.266H86.0511V358.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9943 315.057H55.4141V352.819H70.9943V315.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.33 320.096H84.8203V353.612H142.33V320.096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.084 378.963H112.191V404.578H157.084V378.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.52 346.923H134.641V366.948H160.52V346.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.307 221.577H249.242V278.881H283.307V221.577Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.67 256.284L600.086 236.204L544.661 306.822L570.244 326.902L625.67 256.284Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.303 321.508L664.195 305.727L618.658 363.747L638.765 379.528L684.303 321.508Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33263,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.066 741.797H-32.6602V887.564H898.066V741.797Z",
    fill: "#6C3950"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_15299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 775.983,
    height: 759,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.fd23d38ce2ba4d9025f1ea90ffb3f887.svg";
export { ForwardRef as ReactComponent };